import React from "react";
import { View, StyleSheet } from "react-native";
import { Text } from "components";
import { colors } from "assets/constants";

const SelectedFiltersView: React.FC<{
  title: string;
  values: Array<string>;
}> = (props) => {
  const { title, values } = props;

  return (
    <View style={styles.tagsContainer}>
      <Text color={colors.theme} weight="bold">
        {title}:{" "}
      </Text>
      {values?.map((v, k) => {
        return (
          <View style={styles.tag} key={String(k)}>
            <Text>{v}</Text>
          </View>
        );
      })}
    </View>
  );
};

export default React.memo(SelectedFiltersView);

const styles = StyleSheet.create({
  tagsContainer: {
    flexDirection: "row-reverse",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 2,
    paddingRight: 4,
    margin: 4,
    borderWidth: 1,
    borderColor: "#f6f6f6",
    alignSelf: "flex-end",
  },

  tag: {
    paddingVertical: 3,
    paddingHorizontal: 6,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#f1f1f1",
    marginHorizontal: 2,
  },
});
